import React, { Fragment, Suspense, lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import {
  fetchAnonymousToken,
  fetchRefreshToken,
} from "../src/store/slices/auth-slice";
import { getUserInfo } from "../src/store/slices/profile-slice";
import { getAllCategories, getCategoryTree } from "../src/store/slices/home-slice";
import { fetchTenantConfig } from "../src/store/slices/tenant-slice";
import {
  getCheckoutData,
  getCartData,
} from "../src/store/slices/newCart-slice";
// home page
const HomePage = lazy(() => import("./pages/home/HomePage"));

// shop pages
const ShopCategory = lazy(() => import("./pages/shop/ShopCategory"));
const SearchPage = lazy(() => import("./pages/shop/SearchPage"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
const ProductDetails = lazy(() =>
  import("./pages/shop-product/ProductDetails")
);
const ProductTabRight = lazy(() =>
  import("./pages/shop-product/ProductTabRight")
);
const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
const ProductFixedImage = lazy(() =>
  import("./pages/shop-product/ProductFixedImage")
);

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const Profile = lazy(() => import("./pages/other/Profile"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const Faqs = lazy(() => import("./pages/other/Faqs"));
const OrderHistory = lazy(() => import("./pages/other/OrderHistory"));

const OrderDetails = lazy(() => import("./pages/other/OrderDetails"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const NotAuthorized = lazy(() => import("./pages/other/NotAuthorized"));
const OrderCompleted = lazy(() => import("./pages/other/orderCompleted"));

const App = () => {
  const dispatch = useDispatch();
  let { loggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    if (
      !localStorage.getItem("token") ||
      localStorage.getItem("token") === "undefined"
    ) {
      dispatch(fetchAnonymousToken()).then(function () {
        dispatch(getCartData());
      });
      loggedIn = false;
    } else if (localStorage.getItem("token")) {
      dispatch(fetchRefreshToken()).then(function (data) {
        dispatch(getCartData());
        if (data.payload.success === false) {
          dispatch(fetchAnonymousToken());
          loggedIn = false;
        }
      });
    }

    if (loggedIn === true) {
      dispatch(getCheckoutData());
    }

    dispatch(getAllCategories());
    dispatch(getCategoryTree());
    dispatch(fetchTenantConfig());
  }, [dispatch]);

  // useEffect(() => {
  //   if(!localStorage.getItem("token") || localStorage.getItem("token") === 'undefined'){
  //       dispatch(fetchAnonymousToken());
  //       loggedIn = false;
  //   }
  // }, [dispatch]);

  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            {/* Homepage */}
            <Route path={process.env.PUBLIC_URL + "/"} element={<HomePage />} />
            <Route
              path={process.env.PUBLIC_URL + "/search"}
              element={<SearchPage />}
            />

            {/* Shop pages */}

            <Route
              path={process.env.PUBLIC_URL + "/category/:id"}
              element={<ShopCategory />}
            />

            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:id"}
              element={<ProductDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
              element={<ProductDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
              element={<ProductTabRight />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-sticky/:id"}
              element={<ProductSticky />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-slider/:id"}
              element={<ProductSlider />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
              element={<ProductFixedImage />}
            />

            {/* Blog pages */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={<BlogStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
              element={<BlogNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
              element={<BlogRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={<BlogDetailsStandard />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />

<Route
              path={process.env.PUBLIC_URL + "/order-details/:id"}
              element={<OrderDetails />}
            />

            {/* <Route
                path={process.env.PUBLIC_URL + "/orderCompleted"}
                element={<OrderCompleted/>}
              />  */}
            <Route path={process.env.PUBLIC_URL + "/faqs"} element={<Faqs />} />

            <Route
              path={process.env.PUBLIC_URL + "/notAuthorized"}
              element={<NotAuthorized />}
            />

            {/* Logged In Pages Only */}

            {loggedIn ? (
              <Fragment>
                <Route
                  path={process.env.PUBLIC_URL + "/profile"}
                  element={<Profile />}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/order-history"}
                  element={<OrderHistory />}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  element={<Checkout />}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/orderCompleted"}
                  element={<OrderCompleted />}
                />

                
              </Fragment>
            ) : (
              <Fragment>
                <Route
                  path={process.env.PUBLIC_URL + "/profile"}
                  element={<NotAuthorized />}
                />

                 <Route
                  path={process.env.PUBLIC_URL + "/profile"}
                  element={<NotAuthorized />}
                />

                
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  element={<NotAuthorized />}
                />

                 
<Route
                  path={process.env.PUBLIC_URL + "/order-history"}
                  element={<NotAuthorized />}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/orderCompleted"}
                  element={<NotAuthorized />}
                />
              </Fragment>
            )}

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
